export default __webpack_public_path__ + "static/media/billreynolds_playfield.3de10084.jpg";